import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  href = '#',
  className = '',
  onClick
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (href.startsWith('#') && href.length > 1) {
      e.preventDefault();
      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
    onClick?.();
  };
  const isExternal = href.startsWith('http');
  return <motion.a href={href} onClick={handleClick} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`inline-flex items-center justify-center gap-3 bg-brand-accent hover:bg-brand-accentHover text-brand-dark font-heading font-bold uppercase tracking-wide py-4 px-8 rounded-md shadow-[0_0_20px_rgba(212,160,23,0.3)] transition-colors duration-300 text-lg md:text-xl w-full sm:w-auto text-center ${className}`} aria-label={typeof children === 'string' ? children : 'Call to action button'} data-id="element-157">
      {children}
      <ArrowRight className="w-6 h-6" aria-hidden="true" data-id="element-158" />
    </motion.a>;
}